import smoothScroll from './smoothScroll';
export { defaultOptions } from './smoothScroll';
export default smoothScroll;